export const SEARCH_PARAM_SORT = 'sort';
export const SEARCH_PARAM_SERIES = 'seriesId';
export const SEARCH_PARAM_TOPIC = 'topicId';
export const SEARCH_PARAM_LESSON_NUMBER = 'lessonNumber';
export const SEARCH_PARAM_CHAT_LAGUAGES = 'chatLanguages';
export const SEARCH_PARAM_LAST_LESSON = 'lastLesson';
export const SEARCH_PARAM_LAST_CHAT = 'lastChat';
export const LESSON_ID_SEPARATOR = '__';
